var _regeneratorRuntime = require("/home/doopyon/twunrs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/doopyon/twunrs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _toConsumableArray = require("/home/doopyon/twunrs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/home/doopyon/twunrs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/home/doopyon/twunrs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/doopyon/twunrs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/doopyon/twunrs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/doopyon/twunrs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/home/doopyon/twunrs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/home/doopyon/twunrs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react")) : "function" == typeof define && define.amd ? define(["react"], e) : "object" == typeof exports ? exports["easy-drawing"] = e(require("react")) : t["easy-drawing"] = e(t.react);
}(this, function (t) {
  return function (t) {
    var e = {};

    function s(i) {
      if (e[i]) return e[i].exports;
      var a = e[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return t[i].call(a.exports, a, a.exports, s), a.l = !0, a.exports;
    }

    return s.m = t, s.c = e, s.d = function (t, e, i) {
      s.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: i
      });
    }, s.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, s.t = function (t, e) {
      if (1 & e && (t = s(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var i = Object.create(null);
      if (s.r(i), Object.defineProperty(i, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var a in t) {
        s.d(i, a, function (e) {
          return t[e];
        }.bind(null, a));
      }
      return i;
    }, s.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return s.d(e, "a", e), e;
    }, s.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, s.p = "", s(s.s = 14);
  }([function (t, e) {
    t.exports = function (t, e, s) {
      return e in t ? Object.defineProperty(t, e, {
        value: s,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = s, t;
    };
  }, function (e, s) {
    e.exports = t;
  }, function (t, e, s) {
    "use strict";

    t.exports = s(5);
  }, function (t, e, s) {
    t.exports = s(10);
  }, function (t, e, s) {
    "use strict";

    function i() {
      if (!(this instanceof i)) return new i();
      this.queue = [], this.cache = null;
    }

    i.prototype.matrix = function (t) {
      return 1 === t[0] && 0 === t[1] && 0 === t[2] && 1 === t[3] && 0 === t[4] && 0 === t[5] ? this : (this.cache = null, this.queue.push(t), this);
    }, i.prototype.translate = function (t, e) {
      return 0 === t && 0 === e || (this.cache = null, this.queue.push([1, 0, 0, 1, t, e])), this;
    }, i.prototype.scale = function (t, e) {
      return 1 === t && 1 === e || (this.cache = null, this.queue.push([t, 0, 0, e, 0, 0])), this;
    }, i.prototype.rotate = function (t, e, s) {
      var i, a, h;
      return 0 !== t && (this.translate(e, s), i = t * Math.PI / 180, a = Math.cos(i), h = Math.sin(i), this.queue.push([a, h, -h, a, 0, 0]), this.cache = null, this.translate(-e, -s)), this;
    }, i.prototype.skewX = function (t) {
      return 0 !== t && (this.cache = null, this.queue.push([1, 0, Math.tan(t * Math.PI / 180), 1, 0, 0])), this;
    }, i.prototype.skewY = function (t) {
      return 0 !== t && (this.cache = null, this.queue.push([1, Math.tan(t * Math.PI / 180), 0, 1, 0, 0])), this;
    }, i.prototype.toArray = function () {
      if (this.cache) return this.cache;
      if (!this.queue.length) return this.cache = [1, 0, 0, 1, 0, 0], this.cache;
      if (this.cache = this.queue[0], 1 === this.queue.length) return this.cache;

      for (var t = 1; t < this.queue.length; t++) {
        this.cache = (e = this.cache, s = this.queue[t], [e[0] * s[0] + e[2] * s[1], e[1] * s[0] + e[3] * s[1], e[0] * s[2] + e[2] * s[3], e[1] * s[2] + e[3] * s[3], e[0] * s[4] + e[2] * s[5] + e[4], e[1] * s[4] + e[3] * s[5] + e[5]]);
      }

      var e, s;
      return this.cache;
    }, i.prototype.calc = function (t, e, s) {
      var i;
      return this.queue.length ? (this.cache || (this.cache = this.toArray()), [t * (i = this.cache)[0] + e * i[2] + (s ? 0 : i[4]), t * i[1] + e * i[3] + (s ? 0 : i[5])]) : [t, e];
    }, t.exports = i;
  }, function (t, e, s) {
    "use strict";

    var i = s(6),
        a = s(7),
        h = s(4),
        n = s(8),
        r = s(9);

    function o(t) {
      if (!(this instanceof o)) return new o(t);
      var e = i(t);
      this.segments = e.segments, this.err = e.err, this.__stack = [];
    }

    o.prototype.__matrix = function (t) {
      var e,
          s = this;
      t.queue.length && this.iterate(function (i, a, h, n) {
        var o, c, l, u;

        switch (i[0]) {
          case "v":
            c = 0 === (o = t.calc(0, i[1], !0))[0] ? ["v", o[1]] : ["l", o[0], o[1]];
            break;

          case "V":
            c = (o = t.calc(h, i[1], !1))[0] === t.calc(h, n, !1)[0] ? ["V", o[1]] : ["L", o[0], o[1]];
            break;

          case "h":
            c = 0 === (o = t.calc(i[1], 0, !0))[1] ? ["h", o[0]] : ["l", o[0], o[1]];
            break;

          case "H":
            c = (o = t.calc(i[1], n, !1))[1] === t.calc(h, n, !1)[1] ? ["H", o[0]] : ["L", o[0], o[1]];
            break;

          case "a":
          case "A":
            var p = t.toArray(),
                x = r(i[1], i[2], i[3]).transform(p);

            if (p[0] * p[3] - p[1] * p[2] < 0 && (i[5] = i[5] ? "0" : "1"), o = t.calc(i[6], i[7], "a" === i[0]), "A" === i[0] && i[6] === h && i[7] === n || "a" === i[0] && 0 === i[6] && 0 === i[7]) {
              c = ["a" === i[0] ? "l" : "L", o[0], o[1]];
              break;
            }

            c = x.isDegenerate() ? ["a" === i[0] ? "l" : "L", o[0], o[1]] : [i[0], x.rx, x.ry, x.ax, i[4], i[5], o[0], o[1]];
            break;

          case "m":
            u = a > 0, c = ["m", (o = t.calc(i[1], i[2], u))[0], o[1]];
            break;

          default:
            for (c = [l = i[0]], u = l.toLowerCase() === l, e = 1; e < i.length; e += 2) {
              o = t.calc(i[e], i[e + 1], u), c.push(o[0], o[1]);
            }

        }

        s.segments[a] = c;
      }, !0);
    }, o.prototype.__evaluateStack = function () {
      var t, e;

      if (this.__stack.length) {
        if (1 === this.__stack.length) return this.__matrix(this.__stack[0]), void (this.__stack = []);

        for (t = h(), e = this.__stack.length; --e >= 0;) {
          t.matrix(this.__stack[e].toArray());
        }

        this.__matrix(t), this.__stack = [];
      }
    }, o.prototype.toString = function () {
      var t,
          e,
          s = [];

      this.__evaluateStack();

      for (var i = 0; i < this.segments.length; i++) {
        e = this.segments[i][0], t = i > 0 && "m" !== e && "M" !== e && e === this.segments[i - 1][0], s = s.concat(t ? this.segments[i].slice(1) : this.segments[i]);
      }

      return s.join(" ").replace(/ ?([achlmqrstvz]) ?/gi, "$1").replace(/ \-/g, "-").replace(/zm/g, "z m");
    }, o.prototype.translate = function (t, e) {
      return this.__stack.push(h().translate(t, e || 0)), this;
    }, o.prototype.scale = function (t, e) {
      return this.__stack.push(h().scale(t, e || 0 === e ? e : t)), this;
    }, o.prototype.rotate = function (t, e, s) {
      return this.__stack.push(h().rotate(t, e || 0, s || 0)), this;
    }, o.prototype.skewX = function (t) {
      return this.__stack.push(h().skewX(t)), this;
    }, o.prototype.skewY = function (t) {
      return this.__stack.push(h().skewY(t)), this;
    }, o.prototype.matrix = function (t) {
      return this.__stack.push(h().matrix(t)), this;
    }, o.prototype.transform = function (t) {
      return t.trim() ? (this.__stack.push(a(t)), this) : this;
    }, o.prototype.round = function (t) {
      var e,
          s = 0,
          i = 0,
          a = 0,
          h = 0;
      return t = t || 0, this.__evaluateStack(), this.segments.forEach(function (n) {
        var r = n[0].toLowerCase() === n[0];

        switch (n[0]) {
          case "H":
          case "h":
            return r && (n[1] += a), a = n[1] - n[1].toFixed(t), void (n[1] = +n[1].toFixed(t));

          case "V":
          case "v":
            return r && (n[1] += h), h = n[1] - n[1].toFixed(t), void (n[1] = +n[1].toFixed(t));

          case "Z":
          case "z":
            return a = s, void (h = i);

          case "M":
          case "m":
            return r && (n[1] += a, n[2] += h), a = n[1] - n[1].toFixed(t), h = n[2] - n[2].toFixed(t), s = a, i = h, n[1] = +n[1].toFixed(t), void (n[2] = +n[2].toFixed(t));

          case "A":
          case "a":
            return r && (n[6] += a, n[7] += h), a = n[6] - n[6].toFixed(t), h = n[7] - n[7].toFixed(t), n[1] = +n[1].toFixed(t), n[2] = +n[2].toFixed(t), n[3] = +n[3].toFixed(t + 2), n[6] = +n[6].toFixed(t), void (n[7] = +n[7].toFixed(t));

          default:
            return e = n.length, r && (n[e - 2] += a, n[e - 1] += h), a = n[e - 2] - n[e - 2].toFixed(t), h = n[e - 1] - n[e - 1].toFixed(t), void n.forEach(function (e, s) {
              s && (n[s] = +n[s].toFixed(t));
            });
        }
      }), this;
    }, o.prototype.iterate = function (t, e) {
      var s,
          i,
          a,
          h = this.segments,
          n = {},
          r = !1,
          o = 0,
          c = 0,
          l = 0,
          u = 0;
      if (e || this.__evaluateStack(), h.forEach(function (e, s) {
        var i = t(e, s, o, c);
        Array.isArray(i) && (n[s] = i, r = !0);
        var a = e[0] === e[0].toLowerCase();

        switch (e[0]) {
          case "m":
          case "M":
            return o = e[1] + (a ? o : 0), c = e[2] + (a ? c : 0), l = o, void (u = c);

          case "h":
          case "H":
            return void (o = e[1] + (a ? o : 0));

          case "v":
          case "V":
            return void (c = e[1] + (a ? c : 0));

          case "z":
          case "Z":
            return o = l, void (c = u);

          default:
            o = e[e.length - 2] + (a ? o : 0), c = e[e.length - 1] + (a ? c : 0);
        }
      }), !r) return this;

      for (a = [], s = 0; s < h.length; s++) {
        if (void 0 !== n[s]) for (i = 0; i < n[s].length; i++) {
          a.push(n[s][i]);
        } else a.push(h[s]);
      }

      return this.segments = a, this;
    }, o.prototype.abs = function () {
      return this.iterate(function (t, e, s, i) {
        var a,
            h = t[0],
            n = h.toUpperCase();
        if (h !== n) switch (t[0] = n, h) {
          case "v":
            return void (t[1] += i);

          case "a":
            return t[6] += s, void (t[7] += i);

          default:
            for (a = 1; a < t.length; a++) {
              t[a] += a % 2 ? s : i;
            }

        }
      }, !0), this;
    }, o.prototype.rel = function () {
      return this.iterate(function (t, e, s, i) {
        var a,
            h = t[0],
            n = h.toLowerCase();
        if (h !== n && (0 !== e || "M" !== h)) switch (t[0] = n, h) {
          case "V":
            return void (t[1] -= i);

          case "A":
            return t[6] -= s, void (t[7] -= i);

          default:
            for (a = 1; a < t.length; a++) {
              t[a] -= a % 2 ? s : i;
            }

        }
      }, !0), this;
    }, o.prototype.unarc = function () {
      return this.iterate(function (t, e, s, i) {
        var a,
            h,
            r,
            o = [],
            c = t[0];
        return "A" !== c && "a" !== c ? null : ("a" === c ? (h = s + t[6], r = i + t[7]) : (h = t[6], r = t[7]), 0 === (a = n(s, i, h, r, t[4], t[5], t[1], t[2], t[3])).length ? [["a" === t[0] ? "l" : "L", t[6], t[7]]] : (a.forEach(function (t) {
          o.push(["C", t[2], t[3], t[4], t[5], t[6], t[7]]);
        }), o));
      }), this;
    }, o.prototype.unshort = function () {
      var t,
          e,
          s,
          i,
          a,
          h = this.segments;
      return this.iterate(function (n, r, o, c) {
        var l,
            u = n[0],
            p = u.toUpperCase();
        r && ("T" === p ? (l = "t" === u, "Q" === (s = h[r - 1])[0] ? (t = s[1] - o, e = s[2] - c) : "q" === s[0] ? (t = s[1] - s[3], e = s[2] - s[4]) : (t = 0, e = 0), i = -t, a = -e, l || (i += o, a += c), h[r] = [l ? "q" : "Q", i, a, n[1], n[2]]) : "S" === p && (l = "s" === u, "C" === (s = h[r - 1])[0] ? (t = s[3] - o, e = s[4] - c) : "c" === s[0] ? (t = s[3] - s[5], e = s[4] - s[6]) : (t = 0, e = 0), i = -t, a = -e, l || (i += o, a += c), h[r] = [l ? "c" : "C", i, a, n[1], n[2], n[3], n[4]]));
      }), this;
    }, t.exports = o;
  }, function (t, e, s) {
    "use strict";

    var i = {
      a: 7,
      c: 6,
      h: 1,
      l: 2,
      m: 2,
      r: 4,
      q: 4,
      s: 4,
      t: 2,
      v: 1,
      z: 0
    },
        a = [5760, 6158, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8239, 8287, 12288, 65279];

    function h(t) {
      return t >= 48 && t <= 57;
    }

    function n(t) {
      this.index = 0, this.path = t, this.max = t.length, this.result = [], this.param = 0, this.err = "", this.segmentStart = 0, this.data = [];
    }

    function r(t) {
      for (; t.index < t.max && (10 === (e = t.path.charCodeAt(t.index)) || 13 === e || 8232 === e || 8233 === e || 32 === e || 9 === e || 11 === e || 12 === e || 160 === e || e >= 5760 && a.indexOf(e) >= 0);) {
        t.index++;
      }

      var e;
    }

    function o(t) {
      var e,
          s = t.index,
          i = s,
          a = t.max,
          n = !1,
          r = !1,
          o = !1,
          c = !1;
      if (i >= a) t.err = "SvgPath: missed param (at pos " + i + ")";else if (43 !== (e = t.path.charCodeAt(i)) && 45 !== e || (e = ++i < a ? t.path.charCodeAt(i) : 0), h(e) || 46 === e) {
        if (46 !== e) {
          if (n = 48 === e, e = ++i < a ? t.path.charCodeAt(i) : 0, n && i < a && e && h(e)) return void (t.err = "SvgPath: numbers started with `0` such as `09` are ilegal (at pos " + s + ")");

          for (; i < a && h(t.path.charCodeAt(i));) {
            i++, r = !0;
          }

          e = i < a ? t.path.charCodeAt(i) : 0;
        }

        if (46 === e) {
          for (c = !0, i++; h(t.path.charCodeAt(i));) {
            i++, o = !0;
          }

          e = i < a ? t.path.charCodeAt(i) : 0;
        }

        if (101 === e || 69 === e) {
          if (c && !r && !o) return void (t.err = "SvgPath: invalid float exponent (at pos " + i + ")");
          if (43 !== (e = ++i < a ? t.path.charCodeAt(i) : 0) && 45 !== e || i++, !(i < a && h(t.path.charCodeAt(i)))) return void (t.err = "SvgPath: invalid float exponent (at pos " + i + ")");

          for (; i < a && h(t.path.charCodeAt(i));) {
            i++;
          }
        }

        t.index = i, t.param = parseFloat(t.path.slice(s, i)) + 0;
      } else t.err = "SvgPath: param should start with 0..9 or `.` (at pos " + i + ")";
    }

    function c(t) {
      var e, s;
      s = (e = t.path[t.segmentStart]).toLowerCase();
      var a = t.data;
      if ("m" === s && a.length > 2 && (t.result.push([e, a[0], a[1]]), a = a.slice(2), s = "l", e = "m" === e ? "l" : "L"), "r" === s) t.result.push([e].concat(a));else for (; a.length >= i[s] && (t.result.push([e].concat(a.splice(0, i[s]))), i[s]);) {
        ;
      }
    }

    function l(t) {
      var e,
          s,
          a,
          h = t.max;
      if (t.segmentStart = t.index, function (t) {
        switch (32 | t) {
          case 109:
          case 122:
          case 108:
          case 104:
          case 118:
          case 99:
          case 115:
          case 113:
          case 116:
          case 97:
          case 114:
            return !0;
        }

        return !1;
      }(t.path.charCodeAt(t.index))) {
        if (s = i[t.path[t.index].toLowerCase()], t.index++, r(t), t.data = [], s) {
          for (e = !1;;) {
            for (a = s; a > 0; a--) {
              if (o(t), t.err.length) return;
              t.data.push(t.param), r(t), e = !1, t.index < h && 44 === t.path.charCodeAt(t.index) && (t.index++, r(t), e = !0);
            }

            if (!e) {
              if (t.index >= t.max) break;
              if (!((n = t.path.charCodeAt(t.index)) >= 48 && n <= 57 || 43 === n || 45 === n || 46 === n)) break;
            }
          }

          var n;
          c(t);
        } else c(t);
      } else t.err = "SvgPath: bad command " + t.path[t.index] + " (at pos " + t.index + ")";
    }

    t.exports = function (t) {
      var e = new n(t),
          s = e.max;

      for (r(e); e.index < s && !e.err.length;) {
        l(e);
      }

      return e.err.length ? e.result = [] : e.result.length && ("mM".indexOf(e.result[0][0]) < 0 ? (e.err = "SvgPath: string should start with `M` or `m`", e.result = []) : e.result[0][0] = "M"), {
        err: e.err,
        segments: e.result
      };
    };
  }, function (t, e, s) {
    "use strict";

    var i = s(4),
        a = {
      matrix: !0,
      scale: !0,
      rotate: !0,
      translate: !0,
      skewX: !0,
      skewY: !0
    },
        h = /\s*(matrix|translate|scale|rotate|skewX|skewY)\s*\(\s*(.+?)\s*\)[\s,]*/,
        n = /[\s,]+/;

    t.exports = function (t) {
      var e,
          s,
          r = new i();
      return t.split(h).forEach(function (t) {
        if (t.length) if (void 0 === a[t]) switch (s = t.split(n).map(function (t) {
          return +t || 0;
        }), e) {
          case "matrix":
            return void (6 === s.length && r.matrix(s));

          case "scale":
            return void (1 === s.length ? r.scale(s[0], s[0]) : 2 === s.length && r.scale(s[0], s[1]));

          case "rotate":
            return void (1 === s.length ? r.rotate(s[0], 0, 0) : 3 === s.length && r.rotate(s[0], s[1], s[2]));

          case "translate":
            return void (1 === s.length ? r.translate(s[0], 0) : 2 === s.length && r.translate(s[0], s[1]));

          case "skewX":
            return void (1 === s.length && r.skewX(s[0]));

          case "skewY":
            return void (1 === s.length && r.skewY(s[0]));
        } else e = t;
      }), r;
    };
  }, function (t, e, s) {
    "use strict";

    var i = 2 * Math.PI;

    function a(t, e, s, i) {
      var a = t * s + e * i;
      return a > 1 && (a = 1), a < -1 && (a = -1), (t * i - e * s < 0 ? -1 : 1) * Math.acos(a);
    }

    function h(t, e) {
      var s = 4 / 3 * Math.tan(e / 4),
          i = Math.cos(t),
          a = Math.sin(t),
          h = Math.cos(t + e),
          n = Math.sin(t + e);
      return [i, a, i - a * s, a + i * s, h + n * s, n - h * s, h, n];
    }

    t.exports = function (t, e, s, n, r, o, c, l, u) {
      var p = Math.sin(u * i / 360),
          x = Math.cos(u * i / 360),
          d = x * (t - s) / 2 + p * (e - n) / 2,
          f = -p * (t - s) / 2 + x * (e - n) / 2;
      if (0 === d && 0 === f) return [];
      if (0 === c || 0 === l) return [];
      c = Math.abs(c), l = Math.abs(l);
      var m = d * d / (c * c) + f * f / (l * l);
      m > 1 && (c *= Math.sqrt(m), l *= Math.sqrt(m));

      var v = function (t, e, s, h, n, r, o, c, l, u) {
        var p = u * (t - s) / 2 + l * (e - h) / 2,
            x = -l * (t - s) / 2 + u * (e - h) / 2,
            d = o * o,
            f = c * c,
            m = p * p,
            v = x * x,
            g = d * f - d * v - f * m;
        g < 0 && (g = 0), g /= d * v + f * m;
        var y = (g = Math.sqrt(g) * (n === r ? -1 : 1)) * o / c * x,
            w = g * -c / o * p,
            P = u * y - l * w + (t + s) / 2,
            b = l * y + u * w + (e + h) / 2,
            M = (p - y) / o,
            L = (x - w) / c,
            A = (-p - y) / o,
            k = (-x - w) / c,
            C = a(1, 0, M, L),
            S = a(M, L, A, k);
        return 0 === r && S > 0 && (S -= i), 1 === r && S < 0 && (S += i), [P, b, C, S];
      }(t, e, s, n, r, o, c, l, p, x),
          g = [],
          y = v[2],
          w = v[3],
          P = Math.max(Math.ceil(Math.abs(w) / (i / 4)), 1);

      w /= P;

      for (var b = 0; b < P; b++) {
        g.push(h(y, w)), y += w;
      }

      return g.map(function (t) {
        for (var e = 0; e < t.length; e += 2) {
          var s = t[e + 0],
              i = t[e + 1],
              a = x * (s *= c) - p * (i *= l),
              h = p * s + x * i;
          t[e + 0] = a + v[0], t[e + 1] = h + v[1];
        }

        return t;
      });
    };
  }, function (t, e, s) {
    "use strict";

    var i = Math.PI / 180;

    function a(t, e, s) {
      if (!(this instanceof a)) return new a(t, e, s);
      this.rx = t, this.ry = e, this.ax = s;
    }

    a.prototype.transform = function (t) {
      var e = Math.cos(this.ax * i),
          s = Math.sin(this.ax * i),
          a = [this.rx * (t[0] * e + t[2] * s), this.rx * (t[1] * e + t[3] * s), this.ry * (-t[0] * s + t[2] * e), this.ry * (-t[1] * s + t[3] * e)],
          h = a[0] * a[0] + a[2] * a[2],
          n = a[1] * a[1] + a[3] * a[3],
          r = ((a[0] - a[3]) * (a[0] - a[3]) + (a[2] + a[1]) * (a[2] + a[1])) * ((a[0] + a[3]) * (a[0] + a[3]) + (a[2] - a[1]) * (a[2] - a[1])),
          o = (h + n) / 2;
      if (r < 1e-10 * o) return this.rx = this.ry = Math.sqrt(o), this.ax = 0, this;
      var c = a[0] * a[1] + a[2] * a[3],
          l = o + (r = Math.sqrt(r)) / 2,
          u = o - r / 2;
      return this.ax = Math.abs(c) < 1e-10 && Math.abs(l - n) < 1e-10 ? 90 : 180 * Math.atan(Math.abs(c) > Math.abs(l - n) ? (l - h) / c : c / (l - n)) / Math.PI, this.ax >= 0 ? (this.rx = Math.sqrt(l), this.ry = Math.sqrt(u)) : (this.ax += 90, this.rx = Math.sqrt(u), this.ry = Math.sqrt(l)), this;
    }, a.prototype.isDegenerate = function () {
      return this.rx < 1e-10 * this.ry || this.ry < 1e-10 * this.rx;
    }, t.exports = a;
  }, function (t, e, s) {
    var i = s(11);

    function a(t) {
      return new i(t).getBoundingBox();
    }

    t.exports = a, a.Path = i;
  }, function (t, e, s) {
    var i = s(12),
        a = s(13),
        h = s(2);

    function n(t) {
      this.d = t;
    }

    t.exports = n, n.prototype = {
      getBoundingBox: function getBoundingBox() {
        var t, e;
        return t = new h(this.d), e = new i(), t.abs().unarc().unshort().iterate(function (t, s, i, a) {
          switch (t[0]) {
            case "M":
            case "L":
              e.addPoint(t[1], t[2]);
              break;

            case "H":
              e.addX(t[1]);
              break;

            case "V":
              e.addY(t[1]);
              break;

            case "Q":
              e.addQuadraticCurve(i, a, t[1], t[2], t[3], t[4]);
              break;

            case "C":
              e.addBezierCurve(i, a, t[1], t[2], t[3], t[4], t[5], t[6]);
          }
        }), new a(e);
      }
    };
  }, function (t, e) {
    function s(t, e, s, i) {
      this.x1 = Number.NaN, this.y1 = Number.NaN, this.x2 = Number.NaN, this.y2 = Number.NaN, this.addPoint(t, e), this.addPoint(s, i);
    }

    t.exports = s, s.prototype = {
      width: function width() {
        return this.x2 - this.x1;
      },
      height: function height() {
        return this.y2 - this.y1;
      },
      addPoint: function addPoint(t, e) {
        null != t && ((isNaN(this.x1) || isNaN(this.x2)) && (this.x1 = t, this.x2 = t), t < this.x1 && (this.x1 = t), t > this.x2 && (this.x2 = t)), null != e && ((isNaN(this.y1) || isNaN(this.y2)) && (this.y1 = e, this.y2 = e), e < this.y1 && (this.y1 = e), e > this.y2 && (this.y2 = e));
      },
      addX: function addX(t) {
        this.addPoint(t, null);
      },
      addY: function addY(t) {
        this.addPoint(null, t);
      },
      addQuadraticCurve: function addQuadraticCurve(t, e, s, i, a, h) {
        var n = t + 2 / 3 * (s - t),
            r = e + 2 / 3 * (i - e),
            o = n + 1 / 3 * (a - t),
            c = r + 1 / 3 * (h - e);
        this.addBezierCurve(t, e, n, o, r, c, a, h);
      },
      addBezierCurve: function addBezierCurve(t, e, s, i, a, h, n, r) {
        var o,
            c = [t, e],
            l = [s, i],
            u = [a, h],
            p = [n, r];

        for (this.addPoint(c[0], c[1]), this.addPoint(p[0], p[1]), o = 0; o <= 1; o++) {
          var x = function x(t) {
            return Math.pow(1 - t, 3) * c[o] + 3 * Math.pow(1 - t, 2) * t * l[o] + 3 * (1 - t) * Math.pow(t, 2) * u[o] + Math.pow(t, 3) * p[o];
          },
              d = 6 * c[o] - 12 * l[o] + 6 * u[o],
              f = -3 * c[o] + 9 * l[o] - 9 * u[o] + 3 * p[o],
              m = 3 * l[o] - 3 * c[o];

          if (0 != f) {
            var v = Math.pow(d, 2) - 4 * m * f;

            if (!(v < 0)) {
              var g = (-d + Math.sqrt(v)) / (2 * f);
              0 < g && g < 1 && (0 == o && this.addX(x(g)), 1 == o && this.addY(x(g)));
              var y = (-d - Math.sqrt(v)) / (2 * f);
              0 < y && y < 1 && (0 == o && this.addX(x(y)), 1 == o && this.addY(x(y)));
            }
          } else {
            if (0 == d) continue;
            var w = -m / d;
            0 < w && w < 1 && (0 == o && this.addX(x(w)), 1 == o && this.addY(x(w)));
          }
        }
      }
    };
  }, function (t, e) {
    function s(t) {
      this.x1 = this.minX = t.x1 || 0, this.y1 = this.minY = t.y1 || 0, this.x2 = this.maxX = t.x2 || 0, this.y2 = this.maxY = t.y2 || 0, this.width = t.width() || 0, this.height = t.height() || 0;
    }

    t.exports = s, s.prototype = {
      round: function round(t) {
        return t = t || 0, this.x1 = this.minX = +this.x1.toFixed(t), this.y1 = this.minY = +this.y1.toFixed(t), this.x2 = this.maxX = +this.x2.toFixed(t), this.y2 = this.maxY = +this.y2.toFixed(t), this.width = +this.width.toFixed(t), this.height = +this.height.toFixed(t), this;
      },
      scale: function scale(t) {
        var e = this;
        return t = t || 1, ["x1", "minX", "y1", "minY", "x2", "maxX", "y2", "maxY", "width", "height"].forEach(function (s) {
          e[s] = e[s] * t;
        }), this;
      },
      toString: function toString() {
        return [this.minX, this.minY, this.width, this.height].join(" ");
      }
    };
  }, function (t, e, s) {
    "use strict";

    s.r(e);

    var i = s(0),
        a = s.n(i),
        h = s(1),
        n = s.n(h),
        r = function r(t) {
      var e = [],
          s = null,
          i = function i() {
        for (var i = arguments.length, a = new Array(i), h = 0; h < i; h++) {
          a[h] = arguments[h];
        }

        e = a, s || (s = requestAnimationFrame(function () {
          s = null, t.apply(void 0, e);
        }));
      };

      return i.cancel = function () {
        s && (cancelAnimationFrame(s), s = null);
      }, i;
    };

    function o(t) {
      var e = t,
          s = [],
          i = 20037508.34 * e[0] / 180;
      Math.abs(e[1]) > 85.05112877980659 && (e[1] = 85.05112877980659 * Math.abs(e[1]) / e[1]);
      var a = Math.log(Math.tan((90 + e[1]) * Math.PI / 360)) / (Math.PI / 180);
      return a = 20037508.34 * a / 180, s[0] = i, s[1] = a, s;
    }

    var c = window.devicePixelRatio,
        l = 2 === c ? 1 : 2;

    function u(t, e) {
      t ? e() : setTimeout(function () {
        u(t, e);
      }, 0);
    }

    var p = {
      animQueue: {},
      _a: !1
    };

    function x() {
      Object.values(p.animQueue).forEach(function (t) {
        t();
      }), p._a && window.requestAnimationFrame(x);
    }

    function d(t) {
      var e = "animation_".concat((Math.random() * Math.random()).toString().replace(/\./g, ""));
      return p.animQueue[e] = t, p._a || (window.requestAnimationFrame(x), p._a = !0), {
        stop: function stop() {
          delete p.animQueue[e], 0 === Object.keys(p.animQueue).length && (p._a = !1);
        }
      };
    }

    var f =
    /*#__PURE__*/
    function (_n$a$Component) {
      _inherits(f, _n$a$Component);

      function f() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, f);

        for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
          t[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(f)).call.apply(_getPrototypeOf2, [this].concat(t))), a()(_assertThisInitialized(_this), "canvas", null);
        return _this;
      }

      _createClass(f, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          u(this.canvas, this.initCanvas.bind(this));
        }
      }, {
        key: "initCanvas",
        value: function initCanvas() {
          var t = window.getComputedStyle(this.canvas.parentNode),
              e = window.parseFloat(t.getPropertyValue("width")),
              s = window.parseFloat(t.getPropertyValue("height"));
          this.canvas.style.width = "".concat(e, "px"), this.canvas.style.height = "".concat(s, "px"), this.canvas.width = e * c, this.canvas.height = s * c;
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;

          var t = this.props.style;
          var e = t || {};
          return n.a.createElement("canvas", {
            ref: function ref(t) {
              return _this2.canvas = t;
            },
            style: _objectSpread({}, e)
          });
        }
      }]);

      return f;
    }(n.a.Component);

    var m =
    /*#__PURE__*/
    function () {
      function m(t, e, s, i, a, h, n, r) {
        _classCallCheck(this, m);

        this.points = t, this.context = e, this.fillStyle = s || "rgba(111,149,255,0.4)", this.strokeStyle = i || "rgba(111,149,255,0.4", this.name = a, this.shadowColor = h, this.click = n, this.over = r, this.reover = 0;
      }

      _createClass(m, [{
        key: "createMapPath",
        value: function createMapPath() {
          var _this3 = this;

          Array.isArray(this.points) && (this.context.beginPath(), this.points.forEach(function (t, e) {
            0 === e ? _this3.context.moveTo(t[0], t[1]) : _this3.context.lineTo(t[0], t[1]);
          }), this.context.closePath());
        }
      }, {
        key: "drawMap",
        value: function drawMap(t, e) {
          this.context.save(), this.createMapPath(), this.context.fillStyle = t || this.fillStyle, this.context.strokeStyle = e || this.strokeStyle, this.shadowColor && (this.context.shadowColor = this.shadowColor, this.context.shadowBlur = 10), this.context.fill(), this.context.stroke(), this.drawName(), this.context.restore();
        }
      }, {
        key: "drawName",
        value: function drawName() {
          if (Array.isArray(this.points) && this.name && this.name.text && !1 !== this.name.show) {
            var _t = null,
                _e = null,
                _s = null,
                _i = null,
                _a = (this.points.map(function (a) {
              var h = a[0],
                  n = a[1];
              return _s = null === _s ? h : Math.max(_s, h), _t = null === _t ? h : Math.min(_t, h), _i = null === _i ? n : Math.max(_i, n), _e = null === _e ? n : Math.min(_e, n), {
                x: h,
                y: n
              };
            }), {
              x: (_s + _t) / 2,
              y: (_i + _e) / 2
            });

            var _h = this.name.fontSize || "12px",
                _n = parseFloat(_h);

            var _r = 0;

            for (var _t2 = 0; _t2 < _h.length; _t2 += 1) {
              if (0 !== _t2 && "." !== _h[_t2] && !/^\d+$/.test(_h[_t2])) {
                _r = _t2;
                break;
              }
            }

            this.context.font = "".concat(_n * Math.sqrt(Math.pow(c, 2))).concat(_h.slice(_r), " Arial"), this.context.textAlign = "center", this.context.textBaseline = "middle", this.context.fillStyle = this.name.color || "#fff", this.context.fillText(this.name.text, _a.x, _a.y);
          }
        }
      }, {
        key: "clearMap",
        value: function clearMap() {
          this.createMapPath(), this.context.save(), this.context.clip(), this.context.clearRect(-this.context.canvas.width / 2, -this.context.canvas.height / 2, this.context.canvas.width, this.context.canvas.height), this.context.restore();
        }
      }]);

      return m;
    }();

    var v = 1.7,
        g = (v - 1) / 2 + 1;

    var y =
    /*#__PURE__*/
    function () {
      function y(t, e, s, i, h, n, r) {
        _classCallCheck(this, y);

        a()(this, "animate", function (t) {
          this.tempRadius1 > this.radius * v ? this.tempRadius1 = this.radius : this.tempRadius1 += this.step, this.tempRadius2 > this.radius * v ? this.tempRadius2 = this.radius : this.tempRadius2 += this.step, this.tempRadius3 > this.radius * v ? this.tempRadius3 = this.radius : this.tempRadius3 += this.step, this.drawAnimate(t);
        }), a()(this, "start", function (t) {
          this.timer = d(this.animate.bind(this, t));
        }), a()(this, "stop", function () {
          this.timer && this.timer.stop();
        }), this.x = e, this.y = s, this.radius = i, this.step = i / 150, this.color = h || "yellow", this.context = t, this.tempRadius1 = this.radius, this.tempRadius2 = this.radius * g, this.tempRadius3 = this.radius * v, this.animationID = null, this.click = n, this.over = r, this.reover = 0, this.GENAME = "scatter";
      }

      _createClass(y, [{
        key: "normalized",
        value: function normalized(t, e, s, i, a) {
          return (a - i) * (t - e) / (s - e) + i;
        }
      }, {
        key: "createPath",
        value: function createPath() {
          this.context.beginPath(), this.context.arc(this.x, this.y, this.radius, 0, 2 * Math.PI);
        }
      }, {
        key: "strokePath",
        value: function strokePath(t) {
          this.context.save(), this.context.strokeStyle = t || this.color, this.context.stroke(), this.context.restore();
        }
      }, {
        key: "fillPath",
        value: function fillPath(t) {
          this.context.save(), this.context.fillStyle = t || this.color, this.context.fill(), this.context.restore();
        }
      }, {
        key: "strokeFlashCirclePath",
        value: function strokeFlashCirclePath(t, e) {
          this.context.save(), this.context.beginPath();
          var s = 1 - this.normalized(t, this.radius, this.radius * v, 0, 1);
          this.context.globalAlpha = s < 0 ? .05 : s, this.context.arc(this.x, this.y, t, 0, 2 * Math.PI), this.strokePath(e), this.context.restore();
        }
      }, {
        key: "drawAnimate",
        value: function drawAnimate(t) {
          this.context.save(), this.context.save(), this.context.beginPath(), this.context.arc(this.x, this.y, 2 * this.radius, 0, 2 * Math.PI), this.context.clip(), this.context.clearRect(-this.context.canvas.width / 2, -this.context.canvas.height / 2, this.context.canvas.width, this.context.canvas.height), this.context.restore(), this.createPath(), this.fillPath(t), this.strokeFlashCirclePath(this.tempRadius1, t), this.strokeFlashCirclePath(this.tempRadius2, t), this.strokeFlashCirclePath(this.tempRadius3, t), this.context.restore();
        }
      }]);

      return y;
    }(),
        w = s(2),
        P = s.n(w),
        b = s(3),
        M = s.n(b);

    var L =
    /*#__PURE__*/
    function () {
      function L(_ref) {
        var t = _ref.path,
            e = _ref.context,
            s = _ref.center,
            i = _ref.point,
            a = _ref.ratio,
            h = _ref.color,
            n = _ref.mouseClick,
            r = _ref.mouseOver;

        _classCallCheck(this, L);

        this.svg = window.document.createElementNS("http://www.w3.org/2000/svg", "path"), this.context = e, this.center = s, this.point = _toConsumableArray(i), this.spoint = _toConsumableArray(i), this.ratio = a, this.path = "", this.rotate = 0, this.scale = 1, this.color = h || "yellow", this.draw = "fill", this.realPath = "", this.reover = 0, "string" == typeof t && (this.path = t), "object" == typeof t && (t.hasOwnProperty("rotate") && (this.rotate = t.rotate), t.hasOwnProperty("d") && (this.path = t.d), t.hasOwnProperty("scale") && (this.scale = t.scale), t.hasOwnProperty("color") && (this.color = t.color), t.hasOwnProperty("draw") && (this.draw = t.draw)), this.click = n, this.over = r, this.GENAME = "symbol";
      }

      _createClass(L, [{
        key: "initPath",
        value: function initPath() {
          if ("string" != typeof this.path || 0 === this.path.length) throw new Error("d must not be empty");
          var t = P()(this.path);
          this.realPath = t.rotate(this.rotate).scale(this.scale).rel().toString();
        }
      }, {
        key: "convertPoint",
        value: function convertPoint(t) {
          var e = o(t || this.point);
          this.spoint = [(e[0] - this.center[0]) * this.ratio, (this.center[1] - e[1]) * this.ratio];
        }
      }, {
        key: "reWritePath",
        value: function reWritePath() {
          var t = 0;

          for (var _e2 = 0; _e2 < this.realPath.length; _e2 += 1) {
            if ("m" !== this.realPath[0].toLowerCase()) throw new Error("path should begin with M");

            if (0 !== _e2 && /^[A-Za-z]*$/.test(this.realPath[_e2])) {
              t = _e2;
              break;
            }
          }

          var e = this.realPath.slice(1, t);

          for (var _s2 = 0; _s2 < e.length; _s2 += 1) {
            if (0 !== _s2 && "." !== e[_s2] && !/^\d+$/.test(e[_s2])) {
              t = _s2;
              break;
            }
          }

          var s = window.parseFloat(e.slice(0, t)),
              i = window.parseFloat(e.slice(t));

          try {
            var _t3 = M()(this.realPath),
                _a2 = (_t3.minX + _t3.maxX) / 2 - s,
                _h2 = (_t3.maxY + _t3.minY) / 2 - i,
                _n2 = this.spoint[0] - _a2,
                _r2 = this.spoint[1] - _h2;

            this.realPath = this.realPath.replace(e, "".concat(_n2, " ").concat(_r2));
          } catch (_unused) {
            var _t4 = this.spoint[0],
                _s3 = this.spoint[1];
            this.realPath = this.realPath.replace(e, "".concat(_t4, " ").concat(_s3));
          }
        }
      }, {
        key: "createPath",
        value: function createPath(t) {
          this.svg.setAttributeNS(null, "d", t || this.realPath);
          var e = this.svg.getTotalLength(),
              s = e / 100;
          this.context.beginPath();

          for (var _t5 = 0; _t5 <= e; _t5 += s) {
            var _e3 = parseFloat(this.svg.getPointAtLength(_t5).x),
                _s4 = parseFloat(this.svg.getPointAtLength(_t5).y);

            0 === _t5 && this.context.moveTo(_e3, _s4), 0 !== _t5 && this.context.lineTo(_e3, _s4);
          }

          this.context.closePath();
        }
      }, {
        key: "fillPath",
        value: function fillPath(t) {
          this.context.fillStyle = t || this.color, this.context.fill();
        }
      }, {
        key: "strokePath",
        value: function strokePath(t) {
          this.context.strokeStyle = t || this.color, this.context.stroke();
        }
      }, {
        key: "cleanPath",
        value: function cleanPath() {
          this.context.clip(), this.context.clearRect(-this.context.canvas.width / 2, -this.context.canvas.height / 2, this.context.canvas.width, this.context.canvas.height);
        }
      }, {
        key: "prepareAction",
        value: function prepareAction(t) {
          this.initPath(), Array.isArray(this.center) ? (t && this.convertPoint(t), !t && this.convertPoint()) : this.spoint = t || this.spoint, this.reWritePath(), this.createPath();
        }
      }, {
        key: "fill",
        value: function fill(_ref2) {
          var t = _ref2.color,
              e = _ref2.point;
          this.prepareAction(e), this.fillPath(t);
        }
      }, {
        key: "stroke",
        value: function stroke(_ref3) {
          var t = _ref3.color,
              e = _ref3.point;
          this.prepareAction(e), this.strokePath(t);
        }
      }, {
        key: "render",
        value: function render() {
          var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              t = _ref4.color,
              e = _ref4.point;

          "function" == typeof this[this.draw] && this[this.draw]({
            color: t,
            point: e
          });
        }
      }, {
        key: "clean",
        value: function clean() {
          this.context.save();
          var t = M()(this.realPath),
              e = t.minX - 7 * this.context.lineWidth,
              s = t.minY - 7 * this.context.lineWidth;
          this.context.beginPath(), this.context.rect(e, s, t.height + 14 * this.context.lineWidth, t.width + 14 * this.context.lineWidth), this.cleanPath(), this.context.restore();
        }
      }]);

      return L;
    }();

    var A =
    /*#__PURE__*/
    function () {
      function A(t, e, s, i, a, h) {
        _classCallCheck(this, A);

        var _i$src = i.src,
            n = _i$src === void 0 ? "" : _i$src,
            _i$width = i.width,
            r = _i$width === void 0 ? 50 : _i$width,
            _i$height = i.height,
            o = _i$height === void 0 ? 50 : _i$height,
            _i$offsetX = i.offsetX,
            c = _i$offsetX === void 0 ? .5 : _i$offsetX,
            _i$offsetY = i.offsetY,
            l = _i$offsetY === void 0 ? .5 : _i$offsetY;
        this.x = e, this.y = s, this.context = t, this.src = n, "string" == typeof r && -1 !== r.indexOf("%") && (r = parseFloat(r) / 100 * t.canvas.width), this.width = r, "string" == typeof o && -1 !== o.indexOf("%") && (o = parseFloat(o) / 100 * t.canvas.height), this.height = o, this.offsetX = c, this.offsetY = l, this.click = a, this.over = h, this.reover = 0, this.GENAME = "img";
      }

      _createClass(A, [{
        key: "createPath",
        value: function createPath() {
          this.context.beginPath(), this.context.rect(this.x - this.offsetX * this.width, this.y - this.height * this.offsetY, this.width, this.height);
        }
      }, {
        key: "render",
        value: function render() {
          var _this4 = this;

          return this.image = new Image(this.width, this.height), this.image.src = this.src, new Promise(function (t) {
            _this4.image.onload = function () {
              _this4.context.drawImage(_this4.image, _this4.x - _this4.offsetX * _this4.width, _this4.y - _this4.height * _this4.offsetY, _this4.width, _this4.height), t();
            };
          });
        }
      }]);

      return A;
    }();

    var k =
    /*#__PURE__*/
    function () {
      function k(t) {
        _classCallCheck(this, k);

        this.points = _toConsumableArray(t.points), this.symbol = t.symbol, this.color = t.color || "yellow", this.width = t.width || 2, this.animation = t.animation || "alternate", this.speed = Math.abs(t.speed), this.delay = t.delay || 0, this.context = t.context, this.scontext = t.scontext, this.svg = window.document.createElementNS("http://www.w3.org/2000/svg", "path"), this.path = "", this.pathLength = 0, this.spanLength = 0, this.symPathLength = 0, this.symSpanLength = 0, this.step = 0, this.symStep = 0, this.animationID, this.clip, this.symbolInstance;
      }

      _createClass(k, [{
        key: "getSpeed",
        value: function getSpeed(t) {
          return 1e3 / Math.sqrt(t, 2) + 1;
        }
      }, {
        key: "initSvgPath",
        value: function initSvgPath() {
          var _this5 = this;

          this.points.forEach(function (t, e) {
            0 === e && (_this5.path = "M".concat(t.join(" "))), 0 !== e && (_this5.path = "".concat(_this5.path, "L").concat(t.join(" ")));
          });
        }
      }, {
        key: "initAnimate",
        value: function initAnimate() {
          this.svg.setAttributeNS(null, "d", this.path), this.pathLength = this.svg.getTotalLength(), isNaN(this.speed) || !this.speed ? this.spanLength = this.pathLength / 100 : this.spanLength = this.pathLength / this.getSpeed(this.speed);
        }
      }, {
        key: "initSymbolAnimate",
        value: function initSymbolAnimate(t) {
          var e = Math.abs(t);
          this.svg.setAttributeNS(null, "d", this.path), this.symPathLength = this.svg.getTotalLength(), isNaN(e) || !this.speed ? this.symSpanLength = this.symPathLength / 100 : this.symSpanLength = this.symPathLength / this.getSpeed(e);
        }
      }, {
        key: "initStaticPath",
        value: function initStaticPath() {
          var _this6 = this;

          this.context.beginPath(), this.points.forEach(function (t, e) {
            var _this6$context, _this6$context2;

            0 === e && (_this6$context = _this6.context).moveTo.apply(_this6$context, _toConsumableArray(t)), 0 !== e && (_this6$context2 = _this6.context).lineTo.apply(_this6$context2, _toConsumableArray(t));
          });
        }
      }, {
        key: "stroke",
        value: function stroke() {
          this.context.save(), this.context.strokeStyle = this.color, this.context.lineCap = "round", this.context.lineJoin = "round", this.context.lineWidth = this.width, this.context.stroke(), this.context.restore();
        }
      }, {
        key: "alternate",
        value: function alternate() {
          var _this7 = this;

          this.initSvgPath(), new Promise(function (t) {
            _this7.timeoutID = setTimeout(t, _this7.delay);
          }).then(function () {
            _this7.initAnimate(), _this7.animationID = d(_this7.alternateA.bind(_this7));
          }), this.runSymbol();
        }
      }, {
        key: "alternateA",
        value: function alternateA() {
          this.step >= this.pathLength && (this.step = 0, this.clip = !this.clip), this.step += this.spanLength;
          var t = this.step;
          var e = parseFloat(this.svg.getPointAtLength(t).x),
              s = parseFloat(this.svg.getPointAtLength(t).y);
          t -= this.spanLength;
          var i = parseFloat(this.svg.getPointAtLength(t).x),
              a = parseFloat(this.svg.getPointAtLength(t).y);
          this.clip ? (this.context.beginPath(), this.context.save(), this.context.arc(e, s, this.spanLength, 0, 2 * Math.PI), this.context.clip(), this.context.clearRect(-this.context.canvas.width / 2, -this.context.canvas.height / 2, this.context.canvas.width, this.context.canvas.height), this.context.restore()) : (this.context.beginPath(), this.context.moveTo(i, a), this.context.lineTo(e, s), this.context.save(), this.context.strokeStyle = this.color, this.context.lineWidth = this.width, this.context.stroke(), this.context.restore());
        }
      }, {
        key: "symbolA",
        value: function symbolA() {
          this.symStep >= this.symPathLength && (this.symStep = 0), this.symStep += this.symSpanLength;
          var t = this.symStep;
          var e = parseFloat(this.svg.getPointAtLength(t).x),
              s = parseFloat(this.svg.getPointAtLength(t).y);
          this.symbolInstance && (this.symbolInstance.clean(), this.symbolInstance.render({
            point: [e, s]
          }));
        }
      }, {
        key: "normal",
        value: function normal() {
          this.initStaticPath(), this.stroke(), this.initSvgPath(), this.runSymbol();
        }
      }, {
        key: "runSymbol",
        value: function runSymbol() {
          var _this8 = this;

          this.symbol && "object" == typeof this.symbol && "string" == typeof this.symbol.d && ("number" == typeof this.symbol.delay ? new Promise(function (t) {
            _this8.stimeoutID = setTimeout(t, _this8.symbol.delay);
          }).then(function () {
            _this8.symbolStart();
          }) : this.symbolStart());
        }
      }, {
        key: "symbolStart",
        value: function symbolStart() {
          this.symbolInstance = new L({
            path: this.symbol,
            context: this.scontext,
            point: this.points[0],
            color: this.color
          }), this.symbolInstance.render(), this.initSymbolAnimate(this.symbol.speed), this.symbolAID = d(this.symbolA.bind(this));
        }
      }, {
        key: "stop",
        value: function stop() {
          this.animationID && this.animationID.stop(), this.symbolAID && this.symbolAID.stop(), this.timeoutID && window.clearTimeout(this.timeoutID), this.stimeoutID && window.clearTimeout(this.stimeoutID);
        }
      }]);

      return k;
    }();

    var C =
    /*#__PURE__*/
    function () {
      function C(t, e, s, i, a, h, n) {
        _classCallCheck(this, C);

        this.x = e, this.y = s, this.radius = i, this.color = a || "yellow", this.context = t, this.click = h, this.over = n, this.reover = 0, this.GENAME = "circle";
      }

      _createClass(C, [{
        key: "createPath",
        value: function createPath() {
          this.context.beginPath(), this.context.arc(this.x, this.y, this.radius, 0, 2 * Math.PI);
        }
      }, {
        key: "createLPath",
        value: function createLPath() {
          this.context.beginPath(), this.context.arc(this.x, this.y, 1.5 * this.radius, 0, 2 * Math.PI);
        }
      }, {
        key: "createCleanPath",
        value: function createCleanPath() {
          this.context.beginPath(), this.context.arc(this.x, this.y, 2 * this.radius, 0, 2 * Math.PI);
        }
      }, {
        key: "fillSPath",
        value: function fillSPath(t) {
          this.context.save(), this.context.fillStyle = t || this.color, this.context.fill(), this.context.restore();
        }
      }, {
        key: "fillLPath",
        value: function fillLPath(t) {
          this.context.save(), this.context.globalAlpha = .4, this.context.fillStyle = t || this.color, this.context.fill(), this.context.restore();
        }
      }, {
        key: "fill",
        value: function fill(t) {
          this.createLPath(), this.fillLPath(t), this.createPath(), this.fillSPath(t);
        }
      }, {
        key: "clear",
        value: function clear() {
          this.createCleanPath(), this.context.save(), this.context.clip(), this.context.clearRect(-this.context.canvas.width / 2, -this.context.canvas.height / 2, this.context.canvas.width, this.context.canvas.height), this.context.restore();
        }
      }]);

      return C;
    }();

    var S =
    /*#__PURE__*/
    function () {
      function S(t, e, s, i, a, h, n, r) {
        _classCallCheck(this, S);

        this.text = t || "", this.size = h || "12px", this.x = s, this.y = i, this.color = a || "#fff", this.context = e, this.align = n || "center", this.vertical = r || "middle", this.reover = 0, this.GENAME = "text";
      }

      _createClass(S, [{
        key: "fillText",
        value: function fillText() {
          this.context.save();
          var t = this.size,
              e = parseFloat(t);
          var s = 0;

          for (var _e4 = 0; _e4 < t.length; _e4 += 1) {
            if (0 !== _e4 && "." !== t[_e4] && !/^\d+$/.test(t[_e4])) {
              s = _e4;
              break;
            }
          }

          this.context.font = "".concat(e * Math.sqrt(Math.pow(c, 2))).concat(t.slice(s), " Arial"), this.context.fillStyle = this.color, this.context.textAlign = this.align, this.context.textBaseline = this.vertical, this.context.fillText(this.text, this.x, this.y), this.context.restore();
        }
      }, {
        key: "clearText",
        value: function clearText() {
          this.context.save();
          var t = this.text.length,
              e = this.context.measureText(this.text).width,
              s = Math.ceil(e / t);
          this.context.rect(this.x - Math.ceil(e / 2), this.y - s, 1.5 * e, 1.5 * s), this.context.clip(), this.context.clearRect(-this.context.canvas.width / 2, -this.context.canvas.height / 2, this.context.canvas.width, this.context.canvas.height), this.context.restore();
        }
      }]);

      return S;
    }();

    e.default =
    /*#__PURE__*/
    function (_n$a$Component2) {
      _inherits(_class, _n$a$Component2);

      function _class() {
        var _getPrototypeOf3;

        var _this9;

        _classCallCheck(this, _class);

        for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          t[_key2] = arguments[_key2];
        }

        _this9 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(_class)).call.apply(_getPrototypeOf3, [this].concat(t))), a()(_assertThisInitialized(_this9), "canvas", null), a()(_assertThisInitialized(_this9), "scatterCanvas", null), a()(_assertThisInitialized(_this9), "pathsCanvas", null), a()(_assertThisInitialized(_this9), "pathsymbolCanvas", null), a()(_assertThisInitialized(_this9), "maxLng", null), a()(_assertThisInitialized(_this9), "minLng", null), a()(_assertThisInitialized(_this9), "maxLat", null), a()(_assertThisInitialized(_this9), "minLat", null), a()(_assertThisInitialized(_this9), "centerPoint", null), a()(_assertThisInitialized(_this9), "ratio", null), a()(_assertThisInitialized(_this9), "areaList", []), a()(_assertThisInitialized(_this9), "scatterList", []), a()(_assertThisInitialized(_this9), "pathsList", []), a()(_assertThisInitialized(_this9), "textList", []), a()(_assertThisInitialized(_this9), "initBounds", function () {
          var t = _this9.props.areas;

          if (Array.isArray(t) && t.length > 0) {
            _this9.maxLng = null, _this9.minLng = null, _this9.maxLat = null, _this9.minLat = null;

            for (var _e5 = 0; _e5 < t.length; _e5 += 1) {
              Array.isArray(t[_e5].polygon) && (t[_e5].polygon = t[_e5].polygon.map(function (t) {
                var e = t;
                var s = e[0],
                    i = e[1];
                return null === _this9.maxLng ? _this9.maxLng = s : _this9.maxLng = Math.max(_this9.maxLng, s), null === _this9.minLng ? _this9.minLng = s : _this9.minLng = Math.min(_this9.minLng, s), null === _this9.maxLat ? _this9.maxLat = i : _this9.maxLat = Math.max(_this9.maxLat, i), null === _this9.minLat ? _this9.minLat = i : _this9.minLat = Math.min(_this9.minLat, i), e;
              }));
            }
          }
        }), a()(_assertThisInitialized(_this9), "mapRender", function () {
          _this9.areaList = [], _this9.scatterList.forEach(function (t) {
            "function" == typeof t.stop && t.stop();
          }), _this9.pathsList.forEach(function (t) {
            "function" == typeof t.stop && t.stop();
          }), _this9.textList.forEach(function (t) {
            "function" == typeof t.clearText && t.clearText();
          }), _this9.scatterList = [], _this9.pathsList = [], _this9.initBounds(), _this9.initCenter(), _this9.initAreas(), _this9.renderAreas(), _this9.initScatters(), _this9.initPaths(), _this9.initTexts();
        }), a()(_assertThisInitialized(_this9), "initCenter", function () {
          var t = _this9.props.areas,
              e = _this9.props.size;

          if (Array.isArray(t) && null !== _this9.maxLng && null !== _this9.maxLat && null !== _this9.minLng && null !== _this9.minLat) {
            var _t6 = _this9.canvas.canvas;

            var _s5 = o([_this9.minLng, _this9.minLat]),
                _i2 = o([_this9.maxLng, _this9.maxLat]),
                _a3 = [(_i2[0] + _s5[0]) / 2, (_i2[1] + _s5[1]) / 2],
                _h3 = Math.min(_t6.width, _t6.height),
                _n3 = Math["cover" === e ? "min" : "max"](_i2[1] - _s5[1], _i2[0] - _s5[0]),
                _r3 = Math.sqrt(Math.pow(_h3, 2) + Math.pow(_h3, 2)) / Math.sqrt(Math.pow(_n3, 2) + Math.pow(_n3, 2));

            _this9.ratio = _r3, _this9.centerPoint = _a3;
          }
        }), a()(_assertThisInitialized(_this9), "initAreas", function () {
          var t = _this9.props.areas;
          if (!Array.isArray(t)) return;

          var e = _this9.canvas.canvas.getContext("2d");

          e.translate(e.canvas.width / 2, e.canvas.height / 2);

          for (var _s6 = 0; _s6 < t.length; _s6 += 1) {
            var _i3 = t[_s6];

            if (Array.isArray(_i3.polygon)) {
              var _t7 = _toConsumableArray(_i3.polygon);

              _t7 = _t7.map(function (t) {
                var e = o(t);
                return [(e[0] - _this9.centerPoint[0]) * _this9.ratio, (_this9.centerPoint[1] - e[1]) * _this9.ratio];
              }), _this9.areaList.push(new m(_t7, e, _i3.fillStyle, _i3.strokeStyle, _i3.name, _i3.shadowColor, _i3.mouseClick, _i3.mouseOver));
            }
          }
        }), a()(_assertThisInitialized(_this9), "renderAreas", function () {
          _this9.areaList.forEach(function (t) {
            t.drawMap();
          });
        }), a()(_assertThisInitialized(_this9), "initScatters", function () {
          var t = _this9.props.scatters;

          if (Array.isArray(t)) {
            var _e6 = _this9.scatterCanvas.canvas.getContext("2d");

            _e6.translate(_e6.canvas.width / 2, _e6.canvas.height / 2), t.forEach(
            /*#__PURE__*/
            function () {
              var _ref5 = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee(t) {
                var s, i, a, _s7, _s8, _s9, _h4;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        s = o(t.point), i = (s[0] - _this9.centerPoint[0]) * _this9.ratio, a = (_this9.centerPoint[1] - s[1]) * _this9.ratio;

                        if (!(t.pointAtCanvas && t.pointAtCanvas({
                          x: (i + _e6.canvas.width / 2) / c,
                          y: (a + _e6.canvas.height / 2) / c
                        }), !t.hidden)) {
                          _context.next = 16;
                          break;
                        }

                        if (!t.path) {
                          _context.next = 7;
                          break;
                        }

                        _s7 = new L({
                          path: t.path,
                          context: _e6,
                          center: _this9.centerPoint,
                          point: t.point,
                          ratio: _this9.ratio,
                          color: t.color,
                          mouseClick: t.mouseClick,
                          mouseOver: t.mouseOver
                        });
                        _s7.render(), _this9.scatterList.push(_s7);
                        _context.next = 16;
                        break;

                      case 7:
                        if (!t.img) {
                          _context.next = 14;
                          break;
                        }

                        _s8 = new A(_e6, i, a, t.img, t.mouseClick, t.mouseOver);
                        _context.next = 11;
                        return _s8.render();

                      case 11:
                        _this9.scatterList.push(_s8);

                        _context.next = 16;
                        break;

                      case 14:
                        _h4 = "number" == typeof t.size ? t.size / l : 10;
                        "static" === t.mode ? (_s9 = new C(_e6, i, a, _h4, t.color, t.mouseClick, t.mouseOver)).fill() : (_s9 = new y(_e6, i, a, _h4, t.color, t.mouseClick, t.mouseOver)).start(), _this9.scatterList.push(_s9);

                      case 16:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x) {
                return _ref5.apply(this, arguments);
              };
            }());
          }
        }), a()(_assertThisInitialized(_this9), "initPaths", function () {
          var t = _this9.props.paths;

          if (Array.isArray(t)) {
            var _e7 = _this9.pathsCanvas.canvas.getContext("2d");

            _e7.translate(_e7.canvas.width / 2, _e7.canvas.height / 2);

            var _s10 = _this9.pathsymbolCanvas.canvas.getContext("2d");

            _s10.translate(_s10.canvas.width / 2, _s10.canvas.height / 2), t.forEach(function (t) {
              var i = t.points;
              if (!Array.isArray(i) || i.length < 2) return void console.error("there should be at least two sets of points in path");
              var a = i.map(function (t) {
                var e = o(t);
                return [(e[0] - _this9.centerPoint[0]) * _this9.ratio, (_this9.centerPoint[1] - e[1]) * _this9.ratio];
              }),
                  h = new k({
                points: a,
                symbol: t.symbol,
                width: t.width,
                animation: t.animation,
                color: t.color,
                speed: t.speed,
                delay: t.delay,
                context: _e7,
                scontext: _s10
              });
              "function" == typeof h[t.animation || "alternate"] && h[t.animation || "alternate"](), _this9.pathsList.push(h);
            });
          }
        }), a()(_assertThisInitialized(_this9), "initTexts", function () {
          var t = _this9.props.texts;

          if (Array.isArray(t)) {
            var _e8 = _this9.textCanvas.canvas.getContext("2d");

            _e8.translate(_e8.canvas.width / 2, _e8.canvas.height / 2), t.forEach(function (t) {
              var s = o(t.point),
                  i = (s[0] - _this9.centerPoint[0]) * _this9.ratio,
                  a = (_this9.centerPoint[1] - s[1]) * _this9.ratio;

              if ("string" == typeof t.text) {
                var _s11 = new S(t.text, _e8, i, a, t.color, t.size, t.align, t.vertical);

                _s11.fillText(), _this9.textList.push(_s11);
              }
            });
          }
        }), a()(_assertThisInitialized(_this9), "mapClick", function (t) {
          var e = t.target.getBoundingClientRect(),
              s = t.clientX,
              i = t.clientY,
              a = (s - e.left) * c,
              h = (i - e.top) * c,
              n = _this9.areaList;

          for (var _t8 = 0; _t8 < n.length; _t8 += 1) {
            var _e9 = n[_t8];
            _e9.createMapPath(), _e9.context.isPointInPath(a, h) && "function" == typeof _e9.click && _e9.click({
              x: a / c,
              y: h / c,
              screenX: s,
              screenY: i
            });
          }

          var r = _this9.scatterList;

          for (var _t9 = 0; _t9 < r.length; _t9 += 1) {
            var _e10 = r[_t9];
            _e10.createPath(), _e10.context.isPointInPath(a, h) && "function" == typeof _e10.click && _e10.click({
              x: a / c,
              y: h / c,
              screenX: s,
              screenY: i
            });
          }
        }), a()(_assertThisInitialized(_this9), "overFun", function (t, e, s, i) {
          var a = _this9.areaList;

          for (var _h5 = 0; _h5 < a.length; _h5 += 1) {
            var _n4 = a[_h5];
            "object" == typeof _n4.over && (_n4.createMapPath(), _n4.context.isPointInPath(t, e) ? (_n4.clearMap(), _n4.drawMap(_n4.over.fillStyle), _n4.reover = 1, _this9.runIn(_n4, {
              x: t / c,
              y: e / c,
              screenX: s,
              screenY: i
            })) : 1 === _n4.reover && (_n4.clearMap(), _n4.drawMap(), _this9.runOut(_n4), _n4.reover = 0));
          }

          var h = _this9.scatterList;

          for (var _a4 = 0; _a4 < h.length; _a4 += 1) {
            var _n5 = h[_a4];
            "object" == typeof _n5.over && (_n5.createPath(), _n5.context.isPointInPath(t, e) ? ("symbol" === _n5.GENAME && (_n5.clean(), _n5.render({
              color: _n5.over.color
            })), "scatter" === _n5.GENAME && (_n5.stop(), _n5.start(_n5.over.color)), "circle" === _n5.GENAME && (_n5.clear(), _n5.fill(_n5.over.color)), _n5.reover = 1, _this9.runIn(_n5, {
              x: t / c,
              y: e / c,
              screenX: s,
              screenY: i
            })) : 1 === _n5.reover && ("symbol" === _n5.GENAME && (_n5.clean(), _n5.render()), "scatter" === _n5.GENAME && (_n5.stop(), _n5.start()), "circle" === _n5.GENAME && (_n5.clear(), _n5.fill()), _n5.reover = 0, _this9.runOut(_n5)));
          }
        }), a()(_assertThisInitialized(_this9), "mapOver", function () {
          var t = r(_this9.overFun.bind(_assertThisInitialized(_this9)));
          return function (e) {
            var s = e.target.getBoundingClientRect(),
                i = e.clientX,
                a = e.clientY,
                h = (i - s.left) * c,
                n = (a - s.top) * c;
            t(h, n, i, a);
          };
        }), a()(_assertThisInitialized(_this9), "runIn", function (t, e) {
          "function" == typeof t.over.moveIn && t.over.moveIn(e);
        }), a()(_assertThisInitialized(_this9), "runOut", function (t) {
          "function" == typeof t.over.moveOut && t.over.moveOut();
        });
        return _this9;
      }

      _createClass(_class, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          u(this.canvas.canvas && this.scatterCanvas.canvas && this.pathsCanvas.canvas && this.pathsymbolCanvas.canvas && this.textCanvas.canvas, this.mapRender.bind(this));
        }
      }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps() {
          var _this10 = this;

          setTimeout(function () {
            _this10.canvas.initCanvas(), _this10.scatterCanvas.initCanvas(), _this10.pathsCanvas.initCanvas(), _this10.pathsymbolCanvas.initCanvas(), _this10.textCanvas.initCanvas(), _this10.mapRender();
          }, 0);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.areaList = [], this.scatterList.forEach(function (t) {
            "function" == typeof t.stop && t.stop();
          }), this.pathsList.forEach(function (t) {
            "function" == typeof t.stop && t.stop();
          }), this.scatterList = [], this.pathsList = [];
        }
      }, {
        key: "render",
        value: function render() {
          var _this11 = this;

          var _this$props$zIndex = this.props.zIndex;
          _this$props$zIndex = _this$props$zIndex === void 0 ? {} : _this$props$zIndex;
          var _this$props$zIndex$sc = _this$props$zIndex.scatters,
              t = _this$props$zIndex$sc === void 0 ? 3 : _this$props$zIndex$sc,
              _this$props$zIndex$ar = _this$props$zIndex.areas,
              e = _this$props$zIndex$ar === void 0 ? 1 : _this$props$zIndex$ar,
              _this$props$zIndex$pa = _this$props$zIndex.paths,
              s = _this$props$zIndex$pa === void 0 ? 2 : _this$props$zIndex$pa;
          return n.a.createElement("div", {
            onMouseMove: this.mapOver(),
            onClick: this.mapClick,
            id: "ge-canvas",
            style: {
              position: "relative",
              width: "100%",
              height: "100%"
            }
          }, n.a.createElement(f, {
            ref: function ref(t) {
              return _this11.pathsCanvas = t;
            },
            style: {
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: s
            }
          }), n.a.createElement(f, {
            ref: function ref(t) {
              return _this11.canvas = t;
            },
            style: {
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: e
            }
          }), n.a.createElement(f, {
            ref: function ref(t) {
              return _this11.scatterCanvas = t;
            },
            style: {
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: t
            }
          }), n.a.createElement(f, {
            ref: function ref(t) {
              return _this11.pathsymbolCanvas = t;
            },
            style: {
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 4
            }
          }), n.a.createElement(f, {
            ref: function ref(t) {
              return _this11.textCanvas = t;
            },
            style: {
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 10
            }
          }));
        }
      }]);

      return _class;
    }(n.a.Component);
  }]);
});